import { generateKeyPair } from "jose";
import { decryptJWT, generateJWTAndSecret } from "../functions/encryption";

export const encryptedFetch = async (input,init) => {
    var keyPair = await generateKeyPair("RSA-OAEP");
var publicKey = await crypto.subtle.exportKey("jwk",keyPair.publicKey);
      const {jwt, secret} = await generateJWTAndSecret(publicKey);
     const response = (await fetch(input + `&t=${jwt}&s=${secret}&m=2`,init));
     let results = {};
     if (response.ok) {
        const {response: json} = await response.json();
        const {payload: {results: r}} = await decryptJWT(json,keyPair.privateKey);
        results = r;
     } else {
        results = response.json();
     }
     return {
        json: () => results,
        ok: response.ok,
        status: response.status,
     }
}

